import chatbot from '../../assets/chatbot.webp';
import chatpdfv2Icon from '../../assets/chatpdfv2.webp';
import grammarIcon from '../../assets/grammar-ai.webp';
import teacherIcon from '../../assets/teacher-ai.webp';
import tripsIcon from '../../assets/trips-ai.webp';
import recipeIcon from '../../assets/recipe-maker.webp';
import translateIcon from '../../assets/translate-now.webp';
import searchIcon from '../../assets/search-ai.webp';
import multiChatIcon from '../../assets/multi-chat.webp';
import sitebotIcon from '../../assets/sitebot.webp';
import codingIcon from '../../assets/coding-ai.webp';
import homeworkIcon from '../../assets/homework-help.webp';
import dreamPhotoIcon from '../../assets/dream-photo.webp';
import interiorIcon from '../../assets/interior-ai.webp';
import restorePhotoIcon from '../../assets/restore-photo.webp';
import removeBackgroundIcon from '../../assets/remove-background.webp';
import avatarMakerIcon from '../../assets/avatar-maker-g.webp';
import storyBookIcon from '../../assets/story-book.webp';
import fluxImageGenIcon from '../../assets/flux-imagegen.webp';
// import moreAppsIcon from '../../assets/more-apps.png';
import { getPrefixLocation } from '../../../core/utils/helper';
import { redirectApp, returnAppHref } from '../../../core/utils/app';

const toolLinks = {
    chatpro: `https://${getPrefixLocation()}chatpro.ai-pro.org/chat`,
    chatpdfv2: `https://${getPrefixLocation()}chatpdfv2.ai-pro.org/`,
    convert2english: `https://${getPrefixLocation()}app.ai-pro.org/convert-to-proper-english`,
    teacher_ai: `https://${getPrefixLocation()}teacher.ai-pro.org/`,
    trips_ai: `https://${getPrefixLocation()}chatlibrary.ai-pro.org/ai/travel`,
    recipe_maker: `https://${getPrefixLocation()}chatlibrary.ai-pro.org/ai/recipe`,
    translate_now: `https://${getPrefixLocation()}chatlibrary.ai-pro.org/ai/writing/translate`,
    searchai: `https://${getPrefixLocation()}search.ai-pro.org/`,
    multillm: `https://${getPrefixLocation()}multillm.ai-pro.org/`,
    sitebot: `https://${getPrefixLocation()}sitebot.ai-pro.org/`,
    codingai: `https://${getPrefixLocation()}coding.ai-pro.org/`,
    homework: `https://${getPrefixLocation()}tutor.ai-pro.org/`,
    txt2img: `https://${getPrefixLocation()}app.ai-pro.org/dream-photo`,
    interiorgpt: `https://${getPrefixLocation()}interiorgpt.ai-pro.org/`,
    restorephoto: `https://${getPrefixLocation()}restorephotos.ai-pro.org/`,
    removebg: `https://${getPrefixLocation()}clearbg.ai-pro.org/`,
    avatar_make: `https://${getPrefixLocation()}avatarmaker.ai-pro.org/`,
    storybook: `https://${getPrefixLocation()}storybook.ai-pro.org/`,
    flux: `https://${getPrefixLocation()}flux.ai-pro.org/`,
};

const toolDataTemplate = [
    { id: 'chatbot-pro', name: 'Chatbot Pro', description: 'An AI chat tool with extended capabilities.', icon: chatbot, key: 'chatpro', category: 'chatbots', isPopular: true, isNew: false },
    { id: 'chatpdfv2', name: 'ChatPDF V2', description: 'Lets you ask questions about PDF file.', icon: chatpdfv2Icon, key: 'chatpdfv2', category: 'chatbots', isPopular: false, isNew: true },
    { id: 'grammar-ai', name: 'Grammar AI', description: 'Checks grammar and improves sentence clarity.', icon: grammarIcon, key: 'convert2english', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'teacher-ai', name: 'Teacher AI', description: 'Offers explanations through text and speech.', icon: teacherIcon, key: 'teacher_ai', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'trips-ai', name: 'Trips AI', description: 'Personalized AI Travel Plans.', icon: tripsIcon, key: 'trips_ai', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'recipe-maker', name: 'Recipe Maker', description: 'Suggests recipes from your ingredients.', icon: recipeIcon, key: 'recipe_maker', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'translate-now', name: 'Translate Now', description: 'Instant translations in 100+ languages.', icon: translateIcon, key: 'translate_now', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'search-ai', name: 'Search AI', description: 'Uses current information to answer your questions.', icon: searchIcon, key: 'searchai', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'multi-chat', name: 'Multi-Chat', description: 'Compare AI results side by side.', icon: multiChatIcon, key: 'multillm', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'sitebot', name: 'Sitebot', description: 'Builds chatbots from uploaded documents.', icon: sitebotIcon, key: 'sitebot', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'coding-ai', name: 'Coding AI', description: 'Assists with writing and reviewing code.', icon: codingIcon, key: 'codingai', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'homework-help', name: 'Homework Help', description: 'Helps you solve academic problems.', icon: homeworkIcon, key: 'homework', category: 'chatbots', isPopular: false, isNew: false },
    { id: 'dream-photo', name: 'Dream Photo', description: 'Generate stunning AI art easily.', icon: dreamPhotoIcon, key: 'txt2img', category: 'arts', isPopular: false, isNew: false },
    { id: 'interior-ai', name: 'Interior AI', description: 'Remodel your room instantly.', icon: interiorIcon, key: 'interiorgpt', category: 'arts', isPopular: false, isNew: false },
    { id: 'restore-photo', name: 'Restore Photo', description: 'Restores and enhances your old or blurry photos.', icon: restorePhotoIcon, key: 'restorephoto', category: 'arts', isPopular: false, isNew: false },
    { id: 'remove-background', name: 'Remove Background', description: 'Effortlessly removes image backgrounds.', icon: removeBackgroundIcon, key: 'removebg', category: 'arts', isPopular: false, isNew: false },
    { id: 'avatar-maker', name: 'Avatar Maker', description: 'Turns your photos into life-like characters.', icon: avatarMakerIcon, key: 'avatar_make', category: 'arts', isPopular: false, isNew: false },
    { id: 'story-book', name: 'Story Book', description: 'Creates stunning book illustrations.', icon: storyBookIcon, key: 'storybook', category: 'arts', isPopular: false, isNew: false },
    { id: 'flux-imagegen', name: 'Flux ImageGen', description: 'Generates photorealistic images.', icon: fluxImageGenIcon, key: 'flux', category: 'arts', isPopular: false, isNew: false },
    // { id: 'more-apps', name: 'More Applications', description: 'Coming soon...', icon: moreAppsIcon, key: '#', category: 'arts', isPopular: false, isNew: false },
];

export const getToolsData = (auth) => {

    return toolDataTemplate.map(tool => {
        const baseUrl = toolLinks[tool.key] || '#';
        const fullUrl = baseUrl;
        
        return {
            ...tool,
            link: fullUrl,
            target: returnAppHref(auth, fullUrl) === fullUrl ? '_blank' : '',
            onClick: (e) => {
                e.preventDefault();
                if (returnAppHref(auth, fullUrl) !== fullUrl) {
                    redirectApp(auth, fullUrl);
                } else {
                    window.open(fullUrl, '_blank');
                }
            }
        };
    });
};
